import React from 'react';

import AboutCarousel from '../components/AboutCarousel';
import Container from '../components/Container';
import CustomHead from '../components/CustomHead';
import Footer from '../components/FooterNew';
import ANGELS from '../data/angels';

import Button from '@components/Button';
import HeaderNew from '@components/HeaderNew';
import Heading from '@components/Heading';

// const AnnouncementNotice = ({ children, link }) => {
//   return (
//     <a
//       href={link}
//       className=" p-1 mb-1 hover:opacity-80 relative z-10 cursor-pointer"
//       style={{
//         background: `linear-gradient(132.26deg, #00B2FF 8.76%, #EA8044 38.65%, #EA5A63 55.63%, #EA4476 72.96%)`,
//         borderRadius: `24px`,
//         marginRight: `auto`,
//       }}
//     >
//       <div
//         style={{ borderRadius: `20px` }}
//         className="text-center justify-center bg-cobalt-100 items-center py-3 px-6"
//       >
//         <div className="mx-auto">
//           <div className="font-inter text-black text-sm font-semibold dark:text-white">
//             {children}
//           </div>
//         </div>
//       </div>
//     </a>
//   );
// };

const NewsEntry = ({ date, title, link }) => {
  return (
    <div className="flex space-x-8 items-center">
      <div className="leading-none w-32 font-inter font-medium text-gray-600 text-md tracking-tight">
        {date}
      </div>
      {link ? (
        <a
          href={link}
          className="w-full leading-snug hover:opacity-80 font-inter font-semibold text-black text-md"
        >
          {`${title} ->`}
        </a>
      ) : (
        <div className="w-full leading-snug font-inter font-semibold text-black text-md tracking-tight">
          {title}
        </div>
      )}
    </div>
  );
};

const Metric = ({ number, insight, timing }) => {
  return (
    <div
      style={{ width: 300 }}
      className="text-center text-black flex flex-col md:flex-row items-center space-x-4 my-8"
    >
      <div
        style={{
          background: `linear-gradient(132.26deg, #00B2FF 8.76%, #EA8044 38.65%, #EA5A63 55.63%, #EA4476 72.96%)`,
          WebkitBackgroundClip: `text`,
        }}
        className="text-4xl md:text-6xl font-extrabold tracking-tightest text-transparent font-display"
      >
        {number}
      </div>
      <div className="flex md:flex-col">
        <div className="text-md font-inter font-semibold text-left">
          {insight}
        </div>
        <div className="mx-1 md:mx-0 text-md font-inter font-medium text-left">
          {timing}
        </div>
      </div>
    </div>
  );
};

const BenefitColumn = ({ title, body, image }) => {
  return (
    <div className="flex flex-col bg-gray-50 rounded-xl px-8 py-8">
      {image && (
        <img
          className="h-12 w-12 mb-6 rounded-lg"
          src={`${process.env.NEXT_PUBLIC_ASSET_HOST}${image}`}
        />
      )}

      <p className="font-display text-xl mb-2 text-black font-bold tracking-tightes flex items-center">
        {title}
      </p>

      <p className="font-inter text-sm font-medium leading-relaxed max-w-xs dark:text-bliss">
        {body}
      </p>
    </div>
  );
};

const MemberColumn = ({
  title,
  image,
  subtext,
  logo,
  bw,
  bio,
  linkedin,
  twitter,
  github,
  size = 20,
}) => {
  return (
    <div className="flex flex-col mb-4 group relative">
      {image && (
        <img
          style={{ filter: `saturate(${bw ? 0 : 1})` }}
          className={`h-${size} w-${size} ${
            bio ? 'hover:opacity-90 cursor-pointer' : ''
          } mb-6 rounded-xl shadow-lg`}
          src={`${process.env.NEXT_PUBLIC_ASSET_HOST}${image}`}
        />
      )}

      {bio && (
        <div className="absolute z-10 -top-6 -left-6 invisible group-hover:visible bg-white rounded-2xl p-6">
          {image && (
            <img
              className={`h-20 w-20 mb-6 rounded-xl`}
              src={`${process.env.NEXT_PUBLIC_ASSET_HOST}${image}`}
            />
          )}

          <div className="mb-4 font-inter font-medium transition-opacity max-w-xs text-xs leading-relaxed text-gray-600">
            {bio}
          </div>

          <div className="flex items-center space-x-3">
            {linkedin && (
              <a
                className="hover:opacity-80 border border-gray-200 rounded-full flex items-center justify-center w-8 h-8"
                href={linkedin}
              >
                <img
                  src={`${process.env.NEXT_PUBLIC_ASSET_HOST}/static/about/socials/linkedin.svg`}
                />
              </a>
            )}

            {twitter && (
              <a
                className="hover:opacity-80 border border-gray-200 rounded-full flex items-center justify-center w-8 h-8"
                href={twitter}
              >
                <img
                  src={`${process.env.NEXT_PUBLIC_ASSET_HOST}/static/about/socials/twitter.svg`}
                />
              </a>
            )}

            {github && (
              <a
                className="hover:opacity-80 border border-gray-200 rounded-full flex items-center justify-center w-8 h-8"
                href={github}
              >
                <img
                  src={`${process.env.NEXT_PUBLIC_ASSET_HOST}/static/about/socials/github.svg`}
                />
              </a>
            )}
          </div>

          {/* <a className="uppercase font-semibold rounded-full bg-green-500 text-xs text-white font-inter tracking-wide py-1 px-2">
            Favorite GIF
          </a> */}
        </div>
      )}

      <div className="flex flex-col space-y-1">
        <p className="font-inter text-sm text-black font-semibold tracking-tightes flex items-center">
          {title}
        </p>

        {subtext && (
          <p className="font-inter text-xs font-medium opacity-75 text-gray-600 tracking-tightes flex items-center">
            {subtext}
          </p>
        )}

        {logo && (
          <div className="flex justify-start">
            <img
              className="my-2 h-4"
              src={`${process.env.NEXT_PUBLIC_ASSET_HOST}${logo}`}
            />
          </div>
        )}
      </div>
    </div>
  );
};

const About = () => {
  return (
    <>
      <CustomHead
        meta={{
          title: 'About us | PopSQL',
          description: `We're the company behind a product loved by teams from over 2000 companies including DoorDash, Shipt, Redfin, and Optimizely. What we've built so far is just the beginning. Join us and build a great product, a great culture, and a great company.`,
          image: `${process.env.NEXT_PUBLIC_ASSET_HOST}/static/about/og.jpg`,
        }}
      />
      <main>
        <HeaderNew />

        <Container
          singleColumn
          className={
            'flex fade fade-1 px-10 space-y-12 pb-16 pt-32 max-w-screen-lg w-full'
          }
          additionalStyles={{ padding: 0 }}
        >
          {/* <AnnouncementNotice link="/blog/series-a">
            We've raised our $14M Series A from Tiger Global {`->`}
          </AnnouncementNotice> */}

          {/* <img
            src={`${process.env.NEXT_PUBLIC_ASSET_HOST}/static/about/topspeed-top.png`}
            width={414}
          /> */}

          <Heading className="max-w-3xl fade fade-1">
            We help companies make decisions fast
          </Heading>

          <div className="max-w-3xl flex flex-col space-y-8 text-black font-medium leading-relaxed text-md lg:text-md font-inter fade fade-2">
            <p>
              Every company wants to use data to make informed decisions, and
              SQL is the lingua franca for data. However,{' '}
              <a
                className="border-b border-bliss border-opacity-40 hover:opacity-80"
                href="/sql-editor-buyers-guide/why-data-collaboration-is-broken"
              >
                data collaboration is broken
              </a>
              . People are rewriting each other's queries, switching apps to
              visualize their data, and copying/pasting SQL into Slack.
            </p>
            <p>
              PopSQL solves this by creating a beautiful, fun way to write SQL,
              visualize data, and share results. The product is loved by data
              teams from over 2000 companies including DoorDash, Shipt, Redfin,
              and Optimizely. What we've built so far is just the beginning.
              Join us and build a great product, a great culture, and a great
              company.
            </p>
          </div>

          <div className="bg-gray-50 rounded-xl w-full justify-center px-16 py-4 items-center flex">
            <div className="grid lg:grid-cols-3">
              <Metric
                number={`60K`}
                insight={`Queries`}
                timing={`run per day`}
              />
              <Metric
                number={`1M`}
                insight={`Schedules`}
                timing={`run per week`}
              />
              <Metric number={`$17.4M`} insight={`Total`} timing={`funding`} />
            </div>
          </div>
        </Container>

        <Container
          singleColumn
          className={'flex fade fade-1 px-10 py-16 max-w-screen-lg w-full'}
          additionalStyles={{ padding: 0 }}
        >
          <Heading Tag="h2" size="md" className="my-16">
            How we work
          </Heading>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 fade fade-1 max-w-screen-lg w-full mx-auto gap-6">
            <BenefitColumn
              image="/static/about/b_time.png"
              title="Location and hours"
              body="Our team is spread throughout the Americas. You're free to choose your own hours and schedule your day in such a way that creates work-life harmony."
            />

            <BenefitColumn
              image="/static/about/b_happy.png"
              title="Full benefits"
              body="Full medical, dental, vision, and life insurance for you and your family."
            />

            <BenefitColumn
              image="/static/about/b_charge.png"
              title="Open vacation policy"
              body="Take the time off that you need to recharge and enjoy."
            />

            {/* <BenefitColumn
              image="/static/about/b_pay.png"
              title="Top salary & equity"
              body="We believe in paying top-of-the-market salary and equity. Every employee gets to share in our collective success."
            />

            <BenefitColumn
              image="/static/about/b_briefcase.png"
              title="Company retreats"
              body={
                <>
                  2-3 times per year. As a fully remote team, it's important for
                  us to{' '}
                  <a
                    className="dark:text-bliss border-b border-bliss border-opacity-40 hover:opacity-80"
                    href="https://www.linkedin.com/posts/rahilsondhi_remotework-wfhlife-retreat-activity-6895407435884978176-n_T0/"
                  >
                    get to know our teammates in person
                  </a>
                  .
                </>
              }
            /> */}

            <BenefitColumn
              image="/static/about/b_calendar.png"
              title="Light meetings"
              body="We like to be disciplined about meetings and only have them when necessary. They should be productive, engaging, and enjoyable."
            />

            <BenefitColumn
              image="/static/about/b_wand.png"
              title="High quality"
              body="Whether it's marketing, engineering, or design, we care about our craft and we strive for high quality."
            />

            <BenefitColumn
              image="/static/about/b_diamond.png"
              title="High ownership"
              body="We like when people have high ownership and own projects from start to finish."
            />
          </div>
        </Container>

        <Container
          singleColumn
          className={
            'flex z-10 relative fade fade-1 px-10 mb-16 pt-8 max-w-screen-lg w-full'
          }
          additionalStyles={{ padding: 0 }}
        >
          <Heading size="md" className="my-8">
            Team
          </Heading>

          {/* <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 fade fade-1 mt-16 max-w-screen-lg w-full mx-auto gap-8">
            {TEAM.map((person) => {
              return (
                <div key={person.name}>
                  <MemberColumn
                    bio={Boolean(person.facts) && person.facts[0]}
                    linkedin={person.socials && person.socials.linkedin}
                    twitter={person.socials && person.socials.twitter}
                    github={person.socials && person.socials.github}
                    image={person.image}
                    title={person.name}
                    subtext={person.title}
                  />
                </div>
              );
            })}
          </div> */}
        </Container>

        <AboutCarousel />

        <Container
          singleColumn
          className={'flex fade fade-1 px-10 pb-8 pt-24 max-w-screen-lg w-full'}
          additionalStyles={{ padding: 0 }}
        >
          <Heading Tag="h2" size="md" className="fade fade-1 my-16">
            Our investors
          </Heading>

          <div className="bg-gray-50 rounded-xl grid-cols-2 grid md:grid-cols-4 gap-16 w-full justify-center px-12 py-24 items-center flex">
            <div>
              <img width={172} src="/static/about/investors/tiger.svg" />
            </div>
            <div>
              <img width={172} src="/static/about/investors/gradient.svg" />
            </div>
            <div>
              <img width={172} src="/static/about/investors/yc.svg" />
            </div>
            <div>
              <img width={172} src="/static/about/investors/funders.svg" />
            </div>
          </div>
        </Container>

        <Container
          singleColumn
          className={
            'flex fade fade-1 px-10 mb-12 mt-12 max-w-screen-lg w-full'
          }
          additionalStyles={{ padding: 0 }}
        >
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 fade fade-1 max-w-screen-lg w-full mx-auto gap-8">
            {ANGELS.map((angel) => {
              return (
                <MemberColumn
                  size={16}
                  image={angel.image}
                  key={angel.name}
                  title={angel.name}
                  subtext={angel.title}
                  bw={true}
                />
              );
            })}
          </div>
        </Container>

        <div id="press" className="">
          <Container
            singleColumn
            className={
              'flex fade fade-1 px-10 pb-24 pt-24 max-w-screen-lg w-full'
            }
            additionalStyles={{ padding: 0 }}
          >
            <Heading Tag="h2" size="md" className="fade fade-1 my-16">
              Press
            </Heading>

            <div className="flex flex-col space-y-4 mb-24">
              <NewsEntry
                date="Feb 2022"
                title={"PopSQL aims to be a modern data team's best friend"}
                link="https://techcrunch.com/2022/02/09/popsql-aims-to-be-a-modern-data-teams-best-friend/"
              />
              <hr className="opacity-20" />
              <NewsEntry
                date="Apr 2020"
                title="Software Engineering Daily Podcast"
                link="https://softwareengineeringdaily.com/2020/04/13/collaborative-sql-with-rahil-sondhi/"
              />
              <hr className="opacity-20" />
              <NewsEntry
                date="Sept 2020"
                title="PopSQL raises $3.4M for its collaborative SQL editor"
                link="https://techcrunch.com/2020/09/08/popsql-raises-3-4m-seed-round-for-its-collaborative-sql-editor/"
              />
              <hr className="opacity-20" />
              <NewsEntry
                date="Aug 2019"
                title={`All 84 startups from Y Combinator's S19 Demo Day`}
                link="https://techcrunch.com/2019/08/19/all-84-startups-from-y-combinators-s19-demo-day-1/"
              />
              <hr className="opacity-20" />
              <NewsEntry
                date="Aug 2019"
                title={`Raised $1 million before Y Combinator's Demo Day to make a better database communications tool for distributed teams`}
                link="https://www.businessinsider.com/popsql-rahil-sondhi-seed-funding-y-combinator-demo-day-2019-8"
              />
              <hr className="opacity-20" />
              <div className="flex pt-4">
                <Button
                  hasArrow
                  variant="ghost"
                  className="inline-block -ml-4"
                  href={'/static/press/popsql-presskit-2023.zip'}
                >
                  {`Download press kit`}
                </Button>
              </div>
            </div>
          </Container>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default About;
